var common = require('./common.js')

const emojis = [
	':like:',
	':unlike:',
	':wink:',
	':tongue-out:',
	':tired:',
	':surprised:',
	':smiling:',
	':sleepy:',
	':sad:',
	':neutral:',
	':heart-eyes:',
	':grinning:',
	':crying:',
	':confused:',
	':angry:',

	':cry:',
	':heart_eyes:',
	':neutral_face:',
	':emoji--disappointed:',
	':smile:',
	':open_mouth:',
	':tired_face:',
	':stuck_out_tongue:',
	':moyai:',
	':thumbsdown:',
	':dislike:',
	':thumbsup:',
	':ok_hand:',
	':octopus:',
	':pig2:',
]

function extractEmojis (text) {
	var out = []
	for (var i = 0; i < text.length; i++) {
		for (var e = 0; e < emojis.length; e++) {
			if (text.indexOf(emojis[e], i) !== i) continue
			out.push({ index: i, length: emojis[e].length })
			i += emojis[e].length - 1
			break
		}
	}

	return out
}

function maskEmojis (text) {
	var out = []
	var chars = ''
	for (var i = 0; i < text.length; i++) {
		var found = false
		for (var e = 0; e < emojis.length; e++) {
			if (text.indexOf(emojis[e], i) !== i) continue
			if (chars !== '') out.push({ type: 'text', value: chars })
			out.push({ type: 'emoji', value: emojis[e] })
			i += emojis[e].length - 1
			chars = ''
			found = true
			break
		}
		if (!found) chars += text[i]
	}

	if (chars !== '') {
		out.push({ type: 'text', value: chars })
	}

	return out
}

function extractLinks (text) {
	text = text || ''
	var reg = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gim
	var out = []
	var match
	while ((match = reg.exec(text))) {
		out.push({ index: match.index, length: reg.lastIndex - match.index })
	}

	return out
}

function extractEmails (text) {
	text = text || ''
	var reg = /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/gim

	var out = []
	var match
	while ((match = reg.exec(text))) {
		out.push({ index: match.index, length: reg.lastIndex - match.index })
	}

	return out
}

function extractPhones (msg) {
	msg = msg || ''
	var fgmsg = ''
	// fine-grained msg
	// remove '-' in number-number
	// remove ' ' in number number
	// remove '.' in number.number

	var realchmap = {}
	for (var i = 0; i < msg.length; i++) {
		var ch = msg.charAt(i)

		if (ch !== '.' && ch !== '-' && ch !== ' ') {
			fgmsg += ch
			realchmap[fgmsg.length - 1] = i
			continue
		}

		var prevCh = i > 0 ? msg.charAt(i - 1) : '-'
		var nextCh = i < msg.length - 1 ? msg.charAt(i + 1) : '-'

		if ('0123456789'.indexOf(prevCh) !== -1 && '0123456789'.indexOf(nextCh) !== -1) continue
		fgmsg += ch
		realchmap[fgmsg.length - 1] = i
	}

	var reg = /([0-9]{8,13})/gim

	var out = []
	while ((match = reg.exec(fgmsg))) {
		out.push({ index: realchmap[match.index], length: realchmap[reg.lastIndex - 1] - realchmap[match.index] + 1 })
	}

	return out
}

function extract (text, extractor, type) {
	if (!text) return []
	var out = []
	var lastindex = 0
	var tags = extractor(text)
	if (common.size(tags) === 0) return [{ type: 'text', text }]
	common.each(tags, tag => {
		out.push({ type: 'text', text: text.substr(lastindex, tag.index - lastindex) })
		out.push({ type, text: text.substr(tag.index, tag.length) })
		lastindex = tag.index + tag.length
	})
	var lastTag = common.last(tags)
	out.push({
		type: 'text',
		text: text.substr(lastTag.index + lastTag.length, text.length - lastTag.index + lastTag.length),
	})

	return common.filter(out, o => o.text !== '')
}

function pipeExtracts (text, extractors) {
	var out = []
	if (common.size(extractors) === 0) return [{ type: 'text', text }]
	var ext = extractors.shift()

	var tags = extract(text, ext, ext.type)
	common.each(tags, t => {
		if (t.type !== 'text') return out.push(t)
		out = out.concat(pipeExtracts(t.text, extractors.slice()))
	})

	return out
}

function extractText (text) {
	var link = extractLinks
	link.type = 'link'

	var email = extractEmails
	email.type = 'email'

	var phone = extractPhones
	phone.type = 'phone'

	var emoji = extractEmojis
	emoji.type = 'emoji'

	return pipeExtracts(text, [link, email, phone, emoji])
}

module.exports = {
	extractEmails,
	extractPhones,
	extractLinks,
	extractText,
	extractEmojis,
	emojis,
	maskEmojis,
}
